export const API_END_POINT = process.env.VUE_APP_API_END_POINT

export const API_END_POINT_AUTH = `${API_END_POINT}/auth/`

export const API_END_POINT_USER = `${API_END_POINT}/users/`

export const CONNECT_FACEBOOK = `${API_END_POINT}/connect/facebook`

export const CONNECT_GOOGLE = `${API_END_POINT}/connect/google`

export const GLOT_SECRET_COOKIE = 'glotSecret'

export const TITLE_LOGIN = process.env.VUE_APP_TITLE_LOGIN || 'Connect to EJOY Learning'

// Convert time token expire in day
export const EXPIRED_TOKEN_TIME = process.env.VUE_APP_EXPIRED_TOKEN_TIME || 30


export const DEFAULT_DOMAIN_NAME = 'Glot Dojo'

export const DEFAULT_DOMAIN = `${process.env.VUE_APP_DEFAULT_DOMAIN}/login-success`

export const DEFAULT_REDIRECT_DOMAIN = 'https://ejo.bz/login_success'

export const NAME_FOR_DOMAIN = [
  {
    prefix: 'https://ejoy-english.com',
    name: ['EJOY'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://api.ejoy.io',
    name: ['EJOY'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://ejoyapi.ejoylearning.com',
    name: ['EJOY'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://glotdojo.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://glotdojo.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: DEFAULT_DOMAIN,
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'http://192.168.1.36:3000',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'http://192.168.1.36:3001',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'http://192.168.1.36',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'http://192.168.1',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'http://192.168.49',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'http://localhost',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://localhost',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://ejoylearning.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    prefix: 'https://ejoyverse.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    contain: '.ejoyspace.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    contain: '.ejoyverse.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    contain: '.ejoy.ai',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  },
  {
    contain: '.ejoylearning.com',
    name: ['Epic', 'GlotDojo'],
    icon: 'ejoy_logo.svg'
  }
]


export default {
  API_END_POINT_AUTH,
  EXPIRED_TOKEN_TIME,
  DEFAULT_DOMAIN,
  API_END_POINT_USER,
  CONNECT_FACEBOOK,
  CONNECT_GOOGLE,
  API_END_POINT,
  DEFAULT_DOMAIN_NAME,
  TITLE_LOGIN,
  NAME_FOR_DOMAIN
}